<a
  class="btn btn-action btn-small"
  [routerLink]="{ cxRoute: 'shipmentCreditClaim' } | cxUrl"
  [queryParams]="sharedService.getQueryParamsLocal('shipmentCreditClaim')"
  >
  <i class="fas fa-arrow-left mr-1"></i>
  {{ 'shared.backTo.dispenserCreditClaim' | cxTranslate }}
</a>

@if (agreement) {
  <div class="container">
    <div class="card agreement-detail">
      <div class="row card-body agreement-detail-content">
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserShipment.submittedDate' | cxTranslate }}</b>
          <span>{{ dateCreated | cxDate: 'longDate' }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserShipment.netValue' | cxTranslate }}</b>
          <span>{{ netValue?.formattedValue }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserShipment.gst' | cxTranslate }}</b>
          <span>{{ gst?.formattedValue }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="row align-items-end">
    <div class="col-12 col-md form-group">
      <button class="btn btn-primary btn-small" (click)="downloadCSV()" [disabled]="disableWhenNoDataOrDownloading">
        <i [class]="downloadingCsv ? 'fa fa-spinner fa-spin' : 'fa fa-download'"></i>
        {{ 'dispenserShipment.downloadCreditHistory' | cxTranslate }}
      </button>
    </div>
    <div class="col col-sm-6 col-md form-group">
      <app-custom-search-input
        title="Search Shipment"
        placeholder="Search by Shipment Number #"
        (eventSearch)="onSearch($event)"
      ></app-custom-search-input>
    </div>
    <div class="col col-sm-6 col-md-auto form-group">
      <app-custom-select
        [title]="'shared.filterBy' | cxTranslate"
        (changeValue)="filterChange($event)"
        [options]="filterOptions"
        [clearable]="true"
        placeHolder="Status"
      ></app-custom-select>
    </div>
  </div>
}

@if (entries?.results?.length) {
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    rowId="code"
    override="DispenserShipmentHistoryRow"
    [rows]="entries.results"
    [pagination]="entries.pagination"
    (changePagination)="pageChange($event + 1)"
    [showLoader]="showLoaderOnPagination"
  ></app-custom-table>
} @else {
  @if (showMessageWhenNoData) {
    <app-custom-error [errorMessage]="'shared.noEntries' | cxTranslate"></app-custom-error>
  }
}


@if (showLoaderOnStartupOrWhenNoData) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
